"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _ = require("../..");
var _react2 = require("@emotion/react");
var _Text = _interopRequireDefault(require("../Text"));
var _Alert = _interopRequireDefault(require("../Alert"));
var _file = require("../../utils/file");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FileInput = ({
  multiple,
  accept,
  label,
  invalidMessage,
  text = 'Last opp fil',
  initialFiles = [],
  width = '130px',
  hideFileList,
  icon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconAttachment, {}),
  fileMaxsixe,
  nostyle,
  rotateIcon,
  isControlledState,
  controlledFiles,
  id = 'file-input',
  onChange
}) => {
  const [uncontrolledFiles, setUncontrolledFiles] = (0, _react.useState)(initialFiles);
  const [sizeError, setSizeError] = (0, _react.useState)(false);
  const theme = (0, _react2.useTheme)();
  const files = isControlledState ? controlledFiles || [] : uncontrolledFiles;
  const hiddenFileInput = (0, _react.useRef)(null);
  const handleClick = () => {
    if (!hiddenFileInput.current) return;
    const node = hiddenFileInput.current;
    node.click();
  };
  const handleSetFiles = files => {
    if (isControlledState) return;
    setUncontrolledFiles(files);
  };
  const handleChange = e => {
    if (!e.target.files[0]) return;
    let filesFromEvent = [...Array.from(e.target.files)];
    let valid = true;
    if (fileMaxsixe) valid = (0, _file.isAllFilesValid)(filesFromEvent, fileMaxsixe);
    if (!valid && fileMaxsixe) {
      filesFromEvent = filesFromEvent.filter(x => x.size <= fileMaxsixe); // Filter out invalid files
      setSizeError(true);
    }
    if (!multiple) {
      handleSetFiles([filesFromEvent[0]]);
      onChange(filesFromEvent[0]);
      e.target.value = null;
      return;
    }
    let newFiles = [...files];
    filesFromEvent.forEach(file => {
      newFiles.push(file);
    });
    handleSetFiles(newFiles);
    onChange(newFiles);
  };
  const handleDelete = index => {
    if (!multiple) {
      handleSetFiles([]);
      onChange(null);
      return;
    }
    const arr = [...files];
    arr.splice(index, 1);
    handleSetFiles(arr);
    onChange(arr);

    // resets value of input to trigger on change if user removes and readds same file
    const node = hiddenFileInput.current;
    if (node) node.value = null;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Label, {
      id: id,
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FileWrapper, {
      children: [files.length > 0 && !hideFileList && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DocumentList, {
        children: files.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DocumentWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Document, {
            theme: theme,
            title: item.name,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              size: "14px",
              semibold: true,
              children: item.name
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Delete, {
            nostyle: true,
            onClick: () => handleDelete(index),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconClose, {
              color: theme.alert
            }), "Fjern"]
          })]
        }, index))
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FileWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FileButton, {
          onClick: handleClick,
          width: width,
          type: "button",
          nostyle: nostyle,
          "aria-labelledby": id,
          children: !nostyle ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ButtonContent, {
            children: [text, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icon, {
              rotated: rotateIcon ? 1 : 0,
              children: icon
            })]
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icon, {
            rotated: rotateIcon ? 1 : 0,
            children: icon
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.HiddenInput, {
          type: "file",
          onChange: handleChange,
          multiple: multiple,
          accept: accept,
          ref: hiddenFileInput,
          "aria-hidden": "true"
        })]
      })]
    }), invalidMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ErrorMessage, {
      children: invalidMessage
    }), sizeError && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Alert.default, {
      danger: true,
      onClose: () => setSizeError(false),
      "aria-live": "assertive",
      children: ["Fil kan ikke overstige ", (0, _file.formatBytes)(fileMaxsixe)]
    })]
  });
};
var _default = exports.default = FileInput;